import store from '@/state/store'
import customer from './routes/customer'
import tariff from './routes/tariff'
import sms from './routes/sms'
import dealer from './routes/dealer'
import network from './routes/network'
import tech from './routes/tech'
import sett from './routes/sett'
import report from './routes/report'
import accontant from './routes/accountant'
import stock from './routes/stock'

export default [
  ...customer, 
  ...tariff,
  ...sms,
  ...dealer,
  ...network,
  ...tech,
  ...sett,
  ...report,
  ...accontant,
  ...stock,
  { 
    path: '/login',
    name: 'login',
    component: () => import('./views/account/login'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['authfack/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
    
        store.dispatch('authfack/logout')
        next({ name: 'login' })
        
      },
    },
  },
  {
    path: '/apartman-yonetimi',
    name: 'apartman-yonetimi',
    meta: { resource: 'admin|personel' },
    component: () => import('./views/apartment/index')
  },
  {
    path: '/', 
    name: 'default', 
    meta: { resource: 'admin|dealer|tech|callcenter|personel' }, 
    component: () => import('./views/dashboards/default'),
  },
  {
    path: '/404',
    name: '404',
    component: require('./views/utility/404').default,
  },
  {
    path: '*',
    redirect: '404',
  },
]